import { inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { SanctumAuthService } from '@freesixtyfive/auth';
import { filter, map, take } from 'rxjs';

export const permissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const auth = inject(SanctumAuthService);
  const router = inject(Router);

  const required = route.data['permission'] as string | undefined;
  if (!required) return true;

  if (auth.isAuth()) {
    return (
      auth.permissions().includes(required) || router.createUrlTree(['/start'])
    );
  }

  return toObservable(auth.isAuth).pipe(
    filter(Boolean),
    take(1),
    map(
      () =>
        auth.permissions().includes(required) ||
        router.createUrlTree(['/start']),
    ),
  );
};
